// lib/firebase.js
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration (get this from your Firebase console)
const firebaseConfig = {
  apiKey: "AIzaSyBlNb1s4DUSWo3HhJDddJ-bn5AZ25h-bdk",
  authDomain: "fyp-2024-reserach-hub.firebaseapp.com",
  projectId: "fyp-2024-reserach-hub",
  storageBucket: "fyp-2024-reserach-hub.appspot.com",
  messagingSenderId: "771808669377",
  appId: "1:771808669377:web:0197e264ab9e28ad4cae40",
  measurementId: "G-XGENZHVS00"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Storage
const storage = getStorage(app);

export { storage };
